import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

/** Every clinic and its feature flags — the Super Admin Feature control table. */
export const getFeatureControlApi = createAsyncThunk(
  'featureControl/get',
  async (_, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };

      const res = await fetch(CLINICS.FEATURE_CONTROL_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch feature control');
      }

      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
